import HRlimit from '../../data-provider/models/equipment/HRlimit'
import Slots from '../../data-provider/models/equipment/Slots'
import GlobalSettings from '../models/GlobalSettings'

export const getGlobalSettings = (): GlobalSettings => {
  const armorSelect = document.getElementById('armor-type') as HTMLSelectElement
  const weaponSlots = document.getElementById('weapon-slots') as HTMLSelectElement
  const armorHRlimit = document.getElementById('hrlimit') as HTMLSelectElement
  const decoHRlimit = document.getElementById('hrlimit') as HTMLSelectElement
  const limit = document.getElementById('search-limit') as HTMLInputElement
  const defenseModeSelect = document.getElementById('defense-mode') as HTMLSelectElement;
  const enableNegativeSkillsCheckbox = document.getElementById('enable-negative-skills') as HTMLInputElement

  return {
    armorType: parseInt(armorSelect.value),
    weaponSlots: parseInt(weaponSlots.value) as Slots,
    armorHRlimit: parseInt(armorHRlimit.value) as HRlimit,
    decoHRlimit: parseInt(decoHRlimit.value) as HRlimit,
    limit: parseInt(limit.value),
    defenseMode: defenseModeSelect ? defenseModeSelect.value as 'min' | 'max' : 'min',
    enableNegativeSkills: enableNegativeSkillsCheckbox ? enableNegativeSkillsCheckbox.checked : false,
  }
}
